import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { TermActionBaseProps, TermActionContent } from '../shared/TermAction/types';

import { TermRevocationDesktop } from './desktop';
import { TermRevocationMobile } from './mobile';

export const TermRevocation: React.FC<TermActionBaseProps> = (props) => {
  const content: TermActionContent = {
    title: 'Encerramento de termo',
    serviceName: 'Fee Fixo',
    observation: 'Ao confirmar o encerramento você retornará ao modelo padrão de comissionamento.',
    headerInfoItems: [
      { label: 'Assessor', value: props.termData?.advisorName || '--' },
      { label: 'Válido até', value: props.termData?.expirationDate || '--' },
    ],
    detailsInfoItems: [
      { label: 'Tipo', value: 'Encerramento' },
      { label: 'Taxa acordada', value: props.termData?.feeRate || '--' },
      { label: 'Ativo desde', value: props.termData?.startDate || '--' },
      { label: 'Encerramento em', value: props.termData?.terminationDate || '--' },
    ],
    refuseButtonLabel: 'Continuar ativo',
    acceptButtonLabel: 'Encerrar',
    acceptButtonVariant: 'cancelAction',
    documentTitle: 'Termo de adesão',
  };

  const responsiveContainer = useBreakpointValue({
    base: <TermRevocationMobile {...props} content={content} />,
    sm: <TermRevocationDesktop {...props} content={content} />,
  });

  return responsiveContainer;
};
